import { Form, Input, Button, Card, Typography, Space } from "antd";
import { PrimaryButton } from "../../global/PrimaryButton";
import { UserOutlined, LockOutlined, SafetyCertificateOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

type LoginFormProps = {
  form: any;
  onSubmitForm: () => void;
};

export const LoginFormComponent = ({ form, onSubmitForm }: LoginFormProps) => {
  return (
    <Card bordered={false} style={{ boxShadow: 'none' }}>
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <img 
          src="/Automart Logo Transparent BG.png" 
          alt="Automart Logo" 
          style={{ width: '100px', marginBottom: '16px' }} 
        />
        <Title level={2} style={{ marginBottom: 8, marginTop: 0 }}>Welcome Back</Title>
        <Text type="secondary">Login to manage your dashboard</Text>
      </div>

      <Form 
        form={form} 
        layout="vertical"
        size="large"
        onFinish={onSubmitForm}
      >
        <Form.Item
          name="email_address"
          rules={[
            {
              required: true,
              message: "Please input your email address!",
            },
            {
              type: 'email',
              message: 'Please enter a valid email address!'
            }
          ]}
        >
          <Input 
            placeholder="Email Address" 
            prefix={<UserOutlined style={{ color: '#94a3b8' }} />} 
          />
        </Form.Item>
        
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
          style={{ marginBottom: 8 }}
        >
          <Input.Password
            prefix={<LockOutlined style={{ color: '#94a3b8' }} />}
            placeholder="Password"
          />
        </Form.Item>

        <Form.Item>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="link" size="small" style={{ padding: 0 }}>
              Forgot Password?
            </Button>
          </div>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <PrimaryButton htmlType="submit" block>
            Login
          </PrimaryButton>
        </Form.Item>
      </Form>
      
      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <Text type="secondary" style={{ fontSize: '12px' }}>
          © 2026 Installment Admin Dashboard 3.0. All rights reserved.
        </Text>
      </div>
    </Card>
  );
};
